import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MetiersIndex.css";
import Header from "../header/header";
import Footer from "../commun/Footer";

const fiches = [
  { path: "/fiches/consultant-transformation-digitale", label: "Consultant en Transformation Digitale", intro: "Le consultant en transformation digitale accompagne les entreprises dans leur transition numérique et l'optimisation de leurs processus." },
  { path: "/fiches/ingenieur-ia", label: "Ingénieur en Intelligence Artificielle", intro: "L’ingénieur IA conçoit et déploie des modèles d’apprentissage automatique pour répondre à des problématiques métiers complexes." },
  { path: "/fiches/chef-projet-agile", label: "Chef de Projet Agile", intro: "Le chef de projet agile pilote la réalisation de projets digitaux en mode agile, garantissant la livraison dans les délais et la qualité." },
  { path: "/fiches/consultant-cybersecurite", label: "Consultant en Cybersécurité", intro: "Le consultant cybersécurité protège les systèmes d'information, analyse les risques et met en œuvre les bonnes pratiques de sécurité." },
  { path: "/fiches/developpeur-backend", label: "Développeur Back-End", intro: "Le développeur back-end construit et sécurise l’architecture technique des applications et leur logique métier." },
  { path: "/fiches/cloud", label: "un Ingénieur Cloud", intro: "L’Ingénieur Cloud conçoit, déploie et maintient des infrastructures IT dans des environnements cloud publics." },
  { path: "/fiches/data-analyst", label: "Data Analyst", intro: "Le data analyst transforme les données en analyses exploitables pour orienter les décisions stratégiques de l’entreprise." },
  { path: "/fiches/data-engineer", label: "Data Engineer", intro: "Le data engineer développe les pipelines et l’architecture qui rendent possible l’analyse et l’exploitation des données massives." },
  { path: "/fiches/data-scientist", label: "Data Scientist", intro: "Le data scientist crée des modèles prédictifs et valorise la donnée via l’intelligence artificielle et le machine learning." },
  { path: "/fiches/developpeur-fullstack", label: "Développeur Full-Stack", intro: "Le développeur full-stack maîtrise les technologies front et back pour développer des applications complètes." },
  { path: "/fiches/developpeur-mobile", label: "Développeur Mobile", intro: "Le développeur mobile crée des applications performantes et ergonomiques pour smartphones et tablettes." },
  { path: "/fiches/expert-machine-learning", label: "Expert en Machine Learning", intro: "L’expert ML conçoit et optimise des algorithmes d’apprentissage automatique pour répondre à des enjeux d’innovation." },
  { path: "/fiches/ingenieur-big-data", label: "Ingénieur Big Data", intro: "L’ingénieur big data gère les architectures permettant de stocker et traiter de très grands volumes de données." },
  { path: "/fiches/developpeur-frontend", label: "Développeur Front-End", intro: "Le développeur front-end conçoit les interfaces utilisateurs réactives et accessibles." },
  { path: "/fiches/ingenieur-devops", label: "Ingénieur DevOps", intro: "L’ingénieur DevOps automatise les déploiements, optimise les workflows et garantit la disponibilité des applications." },
  { path: "/fiches/scrum-master", label: "Scrum Master", intro: "Le scrum master facilite la méthodologie agile, l’organisation des sprints et la cohésion de l’équipe de développement." },
  { path: "/fiches/testeur-qa", label: "Testeur QA", intro: "Le testeur QA vérifie la qualité des applications et identifie les anomalies avant leur mise en production." },
  { path: "/fiches/ui-ux-designer", label: "UI/UX Designer", intro: "Le UI/UX designer crée des expériences utilisateurs intuitives et des interfaces graphiques attractives." }
];

const MetiersIndex = () => {
  const [search, setSearch] = useState("");

  const filtered = fiches.filter(
    fiche =>
      fiche.label.toLowerCase().includes(search.toLowerCase()) ||
      fiche.intro.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Header />
      <div className="metiers-index">
        <div className="metiers-hero" >
          <h2>
            Trouvez les meilleurs profils IT avec Cooptaleo
          </h2>
          <p className="metiers-intro">
            <b>Des fiches métiers précises pour des recrutements plus efficaces. </b>Besoin de recruter mais pas encore d’offre claire ? Nos fiches métiers vous aident à viser juste : 
                 missions, compétences, expérience, TJM… <br></br>Ciblez mieux, recrutez plus vite.
          </p>
          <div className="metiers-searchbar">
            <input
              type="text"
              placeholder="Rechercher une fiche métier"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <button>
              Rechercher
            </button>
          </div>
        </div>
        <div className="metiers-cards">
          {filtered.map(fiche => (
            <div className="metier-card" key={fiche.path}>
                <h3>
                <Link to={fiche.path} className="metier-title-link">
                Recruter un {fiche.label}
                </Link>
                </h3>

              <p>{fiche.intro}</p>
              <Link to={fiche.path} className="metier-link">Voir la fiche</Link>
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ marginTop: 32, textAlign: "center" }}>
              <i>Aucune fiche ne correspond à votre recherche.</i>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MetiersIndex;
